export const listTypeInfo = {
  purchaseDemandStatusList: [
    { name: '摇篮到大门（Cradle-to-Gate）', id: 1 },
    { name: '大门到大门（Gate-to-Gate）', id: 2 },
    { name: '摇篮到坟墓（Cradle-to-Grave）', id: 3 },
    { name: '摇篮到摇篮（Cradle-to-Cradle）', id: 4 },
  ],
  purchaseDemandStatusList1: [
    { name: '新建', id: 0 },
    { name: '待审核', id: 1 },
    { name: '审核通过', id: 2 },
    { name: '审核驳回', id: 3 },
    { name: '退回', id: 4 },
  ],
};
const standardOption = {
  1: 'ISO 14067:2018《温室气体 产品碳足迹 关于量化的要求和指南》',
  2: 'PAS 2050:2011《商品和服务在生命周期内的温室气体排放评价规范》',
  3: 'GB/T 24067-2024《温室气体 产品碳足迹 量化要求和指南》',
  4: 'GHG Protocol《温室气体核算体系》',
  5: '其他',
};

const levelOption = {
  1: '国家级',
  2: '省级',
  3: '其他',
};

export const tableLabel = [
  {
    label: '证书出具机构',
    param: 'institutionName',
    align: 'center',
    minWidth: 140,
    // render: (row) => {
    //   // return row.certificateProductName || row.reportProductName;
    // },
  },
  {
    label: '证书编号',
    param: 'reportCode',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '证书有效期',
    param: 'validStart',
    align: 'center',
    minWidth: 140,
    render: (row) => {
      return row.validStart && row.validEnd
        ? `${row.validStart}-${row.validEnd}`
        : '';
    },
  },
  {
    label: '认证标准',
    param: 'standard',
    align: 'center',
    minWidth: 140,
    render: (row) => {
      return standardOption[row.standard];
    },
  },
  {
    label: '认证物资类别',
    param: 'categoryName',
    align: 'center',
    render: (row) => {
      return row.categoryName;
    },
  },
  {
    label: '产品名称',
    param: 'productName',
    align: 'center',
    minWidth: 140,
    // render: (row) => {
    //   // return row.certificateProductName || row.reportProductName;
    // },
  },
  {
    label: '规格型号',
    param: 'specifications',
    align: 'center',
    minWidth: 140,
  },

  {
    label: '系统边界',
    param: 'systemBoundary',
    align: 'center',
    minWidth: 110,
    render: (row) => {
      const match = listTypeInfo.purchaseDemandStatusList.find(
        (item) => item.id == row.systemBoundary
      );
      // listTypeInfo.purchaseDemandStatusList.find(
      //   (item) => item.id == row.certificateSystemBoundary
      // ) ||
      // listTypeInfo.purchaseDemandStatusList.find(
      //   (item) => item.id == row.systemBoundary
      // );
      return match?.name;
    },
  },
  {
    label: '时间边界',
    param: 'timeBoundaryStart',
    align: 'center',
    minWidth: 110,
    render: (row) => {
      return row.timeBoundaryStart && row.timeBoundaryEnd
        ? `${row.timeBoundaryStart}-${row.timeBoundaryEnd}`
        : '';
    },
  },
  {
    label: '功能单位',
    param: 'carbonUnitValue',
    align: 'center',
    minWidth: 110,
    render: (row) => {
      return row.carbonUnitValue
        ? `${row.carbonUnitValue}${row.carbonUnit === 1 ? 'tCO₂e' : 'kgCO₂e'}`
        : '';
    },
  },

  {
    label: '操作',
    align: 'center',
    fixed: 'right',
    width: '140',
    slot: 'handle',
    minWidth: 100,
  },
];

export const tableLabel1 = [
  {
    label: '报告出具机构',
    param: 'institutionName',
    align: 'center',
    minWidth: 140,
    // render: (row) => {
    //   // return row.certificateProductName || row.reportProductName;
    // },
  },
  {
    label: '报告编号',
    param: 'reportCode',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '认证物资类别',
    param: 'categoryName',
    align: 'center',
    render: (row) => {
      return row.categoryName;
    },
  },
  {
    label: '产品名称',
    param: 'productName',
    align: 'center',
    minWidth: 140,
    // render: (row) => {
    //   // return row.certificateProductName || row.reportProductName;
    // },
  },
  {
    label: '规格型号',
    param: 'specifications',
    align: 'center',
    minWidth: 140,
  },

  {
    label: '系统边界',
    param: 'systemBoundary',
    align: 'center',
    minWidth: 110,
    render: (row) => {
      const match = listTypeInfo.purchaseDemandStatusList.find(
        (item) => item.id == row.systemBoundary
      );
      // listTypeInfo.purchaseDemandStatusList.find(
      //   (item) => item.id == row.certificateSystemBoundary
      // ) ||
      // listTypeInfo.purchaseDemandStatusList.find(
      //   (item) => item.id == row.systemBoundary
      // );
      return match?.name;
    },
  },

  {
    label: '操作',
    align: 'center',
    fixed: 'right',
    width: '140',
    slot: 'handle',
    minWidth: 100,
  },
];

export const tableLabel2 = [
  {
    label: '级别',
    param: 'level',
    align: 'center',
    minWidth: 140,
    render: (row) => {
      return levelOption[row.level];
    },
  },
  {
    label: '获评时间',
    param: 'awardYear',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '评价方式',
    param: 'evalMethod',
    align: 'center',
    render: (row) => {
      const evalMethodObj = {
        1: '自评',
        2: '委托第三方机构评级',
      };
      return evalMethodObj[row.evalMethod];
    },
  },
  {
    label: '第三方评价机构名称',
    param: 'institutionName',
    align: 'center',
    minWidth: 140,
    // render: (row) => {
    //   // return row.certificateProductName || row.reportProductName;
    // },
  },
  {
    label: '查询网址',
    param: 'reportAddress',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '操作',
    align: 'center',
    fixed: 'right',
    width: '140',
    slot: 'handle',
    minWidth: 100,
  },
];

export const tableLabel3 = [
  {
    label: '级别',
    param: 'level',
    align: 'center',
    minWidth: 140,
    render: (row) => {
      return levelOption[row.level];
    },
  },
  {
    label: '获评时间',
    param: 'awardYear',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '评价方式',
    param: 'evalMethod',
    align: 'center',
    render: (row) => {
      const evalMethodObj = {
        1: '自评',
        2: '委托第三方机构评级',
      };
      return evalMethodObj[row.evalMethod];
    },
  },
  {
    label: '第三方评价机构名称',
    param: 'institutionName',
    align: 'center',
    minWidth: 140,
    // render: (row) => {
    //   // return row.certificateProductName || row.reportProductName;
    // },
  },
  {
    label: '查询网址',
    param: 'reportAddress',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '操作',
    align: 'center',
    fixed: 'right',
    width: '140',
    slot: 'handle',
    minWidth: 100,
  },
];

export const tableLabel4 = [
  {
    label: '证书编号',
    param: 'reportCode',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '制造商名称',
    param: 'manufacturerName',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '制造商地址',
    param: 'manufacturerAddr',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '制造企业名称',
    param: 'factoryName',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '产品名称',
    param: 'productName',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '系列/规格/型号',
    param: 'specifications',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '依据标准/技术要求',
    param: 'standardName',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '颁证机构',
    param: 'institutionName',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '有效期',
    param: 'validStart',
    align: 'center',
    minWidth: 140,
    render: (row) => {
      return row.validStart && row.validEnd
        ? `${row.validStart}-${row.validEnd}`
        : '';
    },
  },
  {
    label: '认证级别（星级)',
    param: 'certLevel',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '操作',
    align: 'center',
    fixed: 'right',
    width: '140',
    slot: 'handle',
    minWidth: 100,
  },
];

export const tableLabel5 = [
  {
    label: '证书名称',
    param: 'reportName',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '颁证机构',
    param: 'institutionName',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '有效期',
    param: 'validStart',
    align: 'center',
    minWidth: 140,
    render: (row) => {
      return row.validStart && row.validEnd
        ? `${row.validStart}-${row.validEnd}`
        : '';
    },
  },
  {
    label: '查询网址',
    param: 'reportAddress',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '操作',
    align: 'center',
    fixed: 'right',
    width: '140',
    slot: 'handle',
    minWidth: 100,
  },
];
export const fieldList = [
  {
    label: '供应商名称',
    type: 'input',
    value: 'supplierName',
  },
  {
    label: '证书产品名称',
    type: 'input',
    value: 'purchaseDemandCode',
  },
  {
    label: '评价机构名称',
    type: 'input',
    value: 'purchaseDemandCode',
  },
  {
    label: '报告产品名称',
    type: 'input',
    value: 'purchaseDemandCode',
  },
  {
    label: '每功能单位碳足迹数值',
    type: 'select',
    value: 'purchaseDemandStatus',
    list: 'purchaseDemandStatusList',
  },
  {
    label: '物资类别',
    type: 'input',
    value: 'purchaseDemandCode',
  },
  {
    label: '系统边界',
    type: 'select',
    value: 'purchaseDemandStatus1',
    list: 'purchaseDemandStatusList',
  },
  {
    label: '产品碳足迹总量',
    type: 'input',
    value: 'purchaseDemandCode',
  },
  {
    label: '上传',
    type: 'date',
    value: 'createTime',
    defaultTime: ['00:00:00', '23:59:59'],
    valueFormat: 'yyyy-MM-dd HH:mm:ss',
    dateType: 'daterange',
  },
];
